module.exports = __webpack_public_path__ + "img/fondo-desk.76fb12b9.png";